module.exports = __webpack_public_path__ + "static/media/carousel1.7ee9cda4.jpg";